import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {ConservazioneCaricaDocumentoModelloUnicoDichiarazioneAmbientaleStep2Component
} from './conservazione-carica-documento-modello-unico-dichiarazione-ambientale-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-modello-unico-dichiarazione-ambientale-step2', {
            url: '/conservazione-carica-modello-unico-dichiarazione-ambientale',
            ncyBreadcrumb: {
                label: 'Carica Modello Unico Dichiarazione Ambientale',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-modello-unico-dichiarazione-ambientale-step2 flex="100"></conservazione-carica-documento-modello-unico-dichiarazione-ambientale-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoModelloUnicoDichiarazioneAmbientaleStep2Module: string = ng
    .module('conservazione-carica-documento-modello-unico-dichiarazione-ambientale-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
  .component('conservazioneCaricaDocumentoModelloUnicoDichiarazioneAmbientaleStep2', ConservazioneCaricaDocumentoModelloUnicoDichiarazioneAmbientaleStep2Component)
    .config(stateConfig)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-modello-unico-dichiarazione-ambientale-step2/conservazione-carica-documento-modello-unico-dichiarazione-ambientale-step2.module.ts